package com.kanati.admin.components

import androidx.compose.runtime.Composable
import com.kanati.admin.state.MaterialThemePalette
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

enum class BannerTone {
    Info,
    Success,
    Error,
}

@Composable
fun StatusBanner(
    message: String,
    theme: MaterialThemePalette,
    tone: BannerTone = BannerTone.Info,
) {
    val background = when (tone) {
        BannerTone.Error -> theme.errorContainer
        BannerTone.Success -> theme.tertiaryContainer
        BannerTone.Info -> theme.surfaceContainer
    }
    val foreground = when (tone) {
        BannerTone.Error -> theme.onErrorContainer
        BannerTone.Success -> theme.onTertiaryContainer
        BannerTone.Info -> theme.onSurfaceVariant
    }
    val borderColor = when (tone) {
        BannerTone.Error -> theme.error
        BannerTone.Success -> theme.onTertiaryContainer
        BannerTone.Info -> theme.outlineVariant
    }

    Div(
        attrs = {
            style {
                padding(14.px, 16.px)
                borderRadius(18.px)
                property("background", background)
                property("color", foreground)
                property("border", "1px solid $borderColor")
                property("box-shadow", "inset 0 1px 0 ${theme.scrim}")
            }
        }
    ) {
        P(
            attrs = {
                style {
                    margin(0.px)
                    property("font-size", "0.95rem")
                    property("line-height", "1.5")
                    property("white-space", "pre-wrap")
                    property("overflow-wrap", "anywhere")
                }
            }
        ) {
            Text(message)
        }
    }
}
